export interface DocumentRowData {
  id: string;
  name: string;
  description: string;
  firm: string;
  domain: DocumentDomain;
  language: Language;
  status: Status;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface DocumentsResponse {
  items: DocumentRowData[];
  totalItems: number;
}

export interface NewGeneratorRequest {
  name: string;
  description: string;
  firm: string;
  domain: DocumentDomain;
  language: Language;
}

export enum Status {
  Draft = 0,
  Published = 1,
  Unpublished = 2,
}

export enum Language {
  English = 0,
  Hebrew = 1,
}

export enum DocumentDomain {
  Audit = 0,
  Tax = 1,
}
